// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox__checkbox___cfX8-","label":"checkbox__label___g23Bo"};